<template lang="pug">
	.creative--folder.flex-col.space(v-if="folder", :class="{ selected, expanded: !folder.Oid || expanded }")
		.flex-row.justify.align-center.folder
			.flex-row.space.align-center(@click="select")
				fas.icon(:icon="expanded && folder.Items && folder.Items.length ? 'folder-open' : 'folder'", @click.stop="expanded = !folder.Oid || !expanded")
				.folder-name.text-overflow.nowrap(:title="folder.Name") {{folder.Name}}
			.folder-actions.flex-row.align-center
				.adt-button.actions-button.rounded.flex-row.align-center.center(:id="`menuItems_${folder.Oid || 'root'}`", @click="$refs.contextMenu.instance.show()")
					fas(icon="ellipsis", size="xs")
		.absolute
			DxContextMenu(ref="contextMenu", :data-source="menuItems", :target="`#menuItems_${folder.Oid || 'root'}`", :width="200", @item-click="onContextMenuItemClick", cssClass="creative--folder")
		.sub-folders.flex-col(v-if="folder.Items && folder.Items.length && expanded")
			creative-folder(v-for="item in sortFolders(folder.Items)", :folder="item", :expandedStates="expandedStates", @save="v => $emit('save', v)", @delete="v => $emit('delete', v)", @create="v => $emit('create', v)", :parentFolder="folder")
		Popup(v-if="isEditingFolder", :popupVisible="isEditingFolder", :width="340", :height="140")
			.flex-col.space
				.flex-col.field
					.font-small.upper.grey {{$tCaption('Folder name')}}
					DxTextBox(:value.sync="$editingFolder.Name")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="isEditingFolder = false")
				DxButton(:text="$tCaption('Save', '@actions')", type="success", @click="isEditingFolder = false; save()")
</template>
<script>
	import _ from 'lodash';
	import DxContextMenu from 'devextreme-vue/context-menu';
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';

	export default {
		translationCategory: 'creative.CreativeFolders',
		name: 'creative--folders',
		props: ['folder', 'expandedStates', 'parentFolder'],
		components: {
			DxContextMenu, Popup, DxButton, DxTextBox
		},
		data() {
			return {
				expanded: !this.folder.Oid || !!this.expandedStates.value[this.folder.Oid],
				selected: false,
				isEditingFolder: false
			}
		},
		computed: {
			menuItems() {
				return [
					{ text: this.$tCaption('Add sub-folder'), action: 'sub', icon: 'fas fa-folder-plus' },
					{ text: this.$tCaption('Edit'), action: 'edit', icon: 'fas fa-pen', visible: !!this.folder.Oid },
					{ text: this.$tCaption('Delete'), action: 'delete', icon: 'fas fa-times', visible: !!this.folder.Oid },
				];
			}
		},
		watch: {
			folder() {
				this.initInstance();
			},
			expanded() {
				this.$set(this.expandedStates.value, this.folder.Oid, this.expanded);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.creativeFolder = this;
			this.$eventsBus.$on('creative-folder-select', this.onEventsBusFolderSelect);
			this.initInstance();
		},
		destroyed() {
			this.$eventsBus.$off('creative-folder-select', this.onEventsBusFolderSelect);
		},
		methods: {
			edit() {
				this.$editingFolder = _.cloneDeep(this.folder);
				this.isEditingFolder = false;
				this.$nextTick(() => {
					this.isEditingFolder = true;
				});
			},
			onContextMenuItemClick(e) {
				const action = e.itemData.action;
				switch(action) {
					case 'edit':
						this.edit();
						break;
					case 'delete':
						this.delete();
						break;
					case 'sub':
						this.addSubFolder();
						break;
				}
			},
			sortFolders(items) {
				return _.orderBy(items, ['Name']);
			},
			initInstance() {
				if (!this.folder.hasOwnProperty('__instance')) {
					let instance = this;
					Object.defineProperty(this.folder, '__instance', {
						get: () => instance,
						set: (v) => instance = v
					});
				} else {
					this.folder.__instance = this;
				}
			},
			onEventsBusFolderSelect(folder) {
				const newSelected = folder.Oid == this.folder.Oid;
				if (this.folder.Oid && newSelected && (this.selected === newSelected || !this.expanded)) {
					this.expanded = !this.expanded;
				}
				this.selected = newSelected;
			},
			select() {
				this.$eventsBus.$emit('creative-folder-select', this.folder);
			},
			save() {
				_.assign(this.folder, this.$editingFolder);
				this.$emit('save', this.$editingFolder);
			},
			delete() {
				this.$emit('delete', this.folder);
			},
			addSubFolder() {
				this.$emit('create', this.folder);
			},
			expandParents() {
				if (this.parentFolder?.__instance) {
					this.parentFolder.__instance.expanded = true;
					this.parentFolder.__instance.expandParents();
				}
			}
		}
	};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.creative--folder {
		min-width: 150px;
		cursor: pointer;
		transition: 0.3s;
		font-weight: 100;
		user-select: none;
		font-size: 13px;
		position: relative;

		.folder {
			.icon {
				color: #b9b9bc;
				transition: 0.3s;
			}

			.folder-name {
				max-width: 150px;
			}
		}

		.actions-button {
			background: transparent;
			color: #c1c1c1;

			&:hover {
				background: #efefef;
				color: #333;
			}
		}

		&.selected {
			> .folder {
				.icon, .folder-name {
					color: $base-accent;
				}
			}
		}

		.folder:hover {
			.icon, .folder-name {
				color: $base-accent;
			}
		}

		> .sub-folders {
			margin-left: 10px;
		}

		.dx-item.dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon {
			font-size: 12px !important;
		}

		.dx-context-menu .dx-menu-item .dx-menu-item-content {
			padding: 3px 6px 4px;
		}

		> .dx-submenu .dx-item > .dx-item-content.dx-menu-item-content .dx-icon {
			margin-right: 4px !important;
		}
	}
</style>